(function () {
  'use strict';

  var requests = new Map();
  var currentRun = 0;

  function sectionUrl(ids, next) {
    var catalog = document.documentElement.getAttribute('data-er-catalog-url') || '/collections/all';
    var url = new URL(next || catalog, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Invalid catalog origin');
    url.searchParams.delete('section_id');
    url.searchParams.delete('sections[]');
    url.searchParams.set('sections', ids.join(','));
    url.searchParams.set('filter.v.availability', '1');
    url.searchParams.set('sort_by', 'best-selling');
    if (!next) url.searchParams.delete('page');
    var preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    return url.href;
  }

  function requestSections(ids, next) {
    var url = sectionUrl(ids, next);
    if (!requests.has(url)) {
      var controller = new AbortController();
      var timeout = window.setTimeout(function () { controller.abort(); }, 10000);
      var pending = fetch(url, {credentials: 'same-origin', signal: controller.signal})
        .then(function (response) {
          if (!response.ok) throw new Error('Catalog request failed');
          return response.json();
        })
        .catch(function (error) { requests.delete(url); throw error; })
        .finally(function () { window.clearTimeout(timeout); });
      requests.set(url, pending);
    }
    return requests.get(url);
  }

  function fragment(html, selector) {
    if (typeof html !== 'string') return null;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  function normalise(text) {
    return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('it').trim();
  }

  function filterDirectory(directory) {
    var input = directory.querySelector('[data-er-brand-search]');
    var term = normalise(input && input.value);
    var links = directory.querySelectorAll('[data-er-brand-key]');
    var shown = 0;
    links.forEach(function (link) {
      var match = normalise(link.textContent).indexOf(term) !== -1;
      link.hidden = !match;
      if (match) shown++;
    });
    var count = directory.querySelector('[data-er-brand-count]');
    if (count) count.textContent = shown + ' brand' + (term ? (shown === 1 ? ' trovato' : ' trovati') : (shown === 1 ? ' disponibile' : ' disponibili'));
    var empty = directory.querySelector('[data-er-brand-empty]');
    if (empty) empty.hidden = shown !== 0;
  }

  function initDirectories() {
    document.querySelectorAll('[data-er-brand-directory]').forEach(function (directory) {
      var input = directory.querySelector('[data-er-brand-search]');
      if (input && !input.dataset.erBound) {
        input.dataset.erBound = 'true';
        input.addEventListener('input', function () { filterDirectory(directory); });
      }
      filterDirectory(directory);
    });
  }

  function updateBrands(html) {
    var source = fragment(html, '[data-er-brand-source]');
    if (!source || source.dataset.erFilterReady !== 'true') return;
    var brands = Array.from(source.querySelectorAll('[data-er-brand-key]'));
    brands.sort(function (a, b) { return a.textContent.localeCompare(b.textContent, 'it', {sensitivity: 'base'}); });
    var byKey = new Map();
    brands.forEach(function (link) { byKey.set(link.dataset.erBrandKey, link); });
    document.querySelectorAll('[data-er-brand-list]').forEach(function (list) {
      var selected = brands;
      if (list.dataset.erBrandList === 'featured') {
        selected = [];
        var seen = new Set();
        var section = list.closest('[data-er-featured-brands]');
        var script = section && section.querySelector('[data-er-preferred-brands]');
        var preferred = [];
        try { preferred = JSON.parse(script ? script.textContent : '[]'); } catch (error) { /* Alphabetical fallback. */ }
        preferred.forEach(function (brand) {
          if (byKey.has(brand.key) && !seen.has(brand.key)) {
            var link = byKey.get(brand.key).cloneNode(true);
            if (brand.label) link.querySelector('.er-brand-name').textContent = brand.label;
            selected.push(link);
            seen.add(brand.key);
          }
        });
        brands.forEach(function (link) {
          if (!seen.has(link.dataset.erBrandKey)) selected.push(link);
        });
        selected = selected.slice(0, Number(list.dataset.erBrandLimit) || 5);
      }
      var nodes = document.createDocumentFragment();
      selected.forEach(function (link) { nodes.appendChild(link.cloneNode(true)); });
      list.replaceChildren(nodes);
      if (list.dataset.erBrandList === 'featured' && list.closest('[data-er-featured-brands]')) {
        list.closest('[data-er-featured-brands]').hidden = selected.length === 0;
      }
    });
    initDirectories();
  }

  async function loadBestsellers(section, html, run) {
    var grid = section.querySelector('[data-er-bestseller-cards]');
    var status = section.querySelector('[data-er-bestseller-status]');
    if (!grid) return;
    grid.setAttribute('aria-busy', 'true');
    var limit = Number(section.dataset.erLimit) === 4 ? 4 : 6;
    var cards = [];
    var seen = new Set();
    var pages = new Set();
    var attempts = 0;
    var failed = false;
    try {
      while (cards.length < limit) {
        var page = fragment(html, '[data-er-bestseller-cards]');
        if (!page) throw new Error('Missing bestseller section');
        page.querySelectorAll('[data-er-bestseller-item]').forEach(function (item) {
          var id = item.dataset.erProductId;
          if (id && !seen.has(id) && cards.length < limit) {
            seen.add(id);
            cards.push(item.cloneNode(true));
          }
        });
        var next = page.dataset.erNext;
        if (cards.length >= limit || !next || pages.has(next) || attempts >= 10) break;
        pages.add(next);
        attempts++;
        var data = await requestSections(['erredue-bestsellers'], next);
        if (run !== currentRun || !section.isConnected) return;
        html = data['erredue-bestsellers'];
      }
    } catch (error) { failed = true; }
    if (run !== currentRun || !section.isConnected) return;
    var nodes = document.createDocumentFragment();
    cards.forEach(function (item) { nodes.appendChild(item); });
    grid.replaceChildren(nodes);
    grid.classList.toggle('er-bestsellers__grid--four', limit === 4);
    grid.setAttribute('aria-busy', 'false');
    if (status) {
      status.hidden = cards.length > 0;
      status.textContent = failed ? 'Scopri i più venduti dal link qui sopra.' : 'Esplora il catalogo per trovare il tuo prossimo acquisto.';
    }
  }

  function init() {
    var run = ++currentRun;
    initDirectories();
    var sections = Array.from(document.querySelectorAll('[data-er-bestsellers]')).filter(function (section) { return section.dataset.erSelection !== 'manual'; });
    var ids = ['erredue-brand-source'];
    if (sections.length) ids.push('erredue-bestsellers');
    if (!document.querySelector('[data-er-brand-list]') && !sections.length) return;
    requestSections(ids).then(function (data) {
      if (run !== currentRun) return;
      updateBrands(data['erredue-brand-source']);
      sections.forEach(function (section) { loadBestsellers(section, data['erredue-bestsellers'], run); });
    }).catch(function () {
      if (run !== currentRun) return;
      sections.forEach(function (section) { loadBestsellers(section, null, run); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
